import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, Typography, Grid } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import DotsMenu from "@icarius-common/dotsMenu";
import ProfileImg from "@icarius-common/profileImg";
import MenuItem from "@material-ui/core/MenuItem";
import { getAppColor, getUserData } from "@icarius-app/selectors";
import { IMAGES_ENDPOINT } from "@icarius-connection/endpoints";
import paths from "@icarius-router/paths";
import Counter from "@icarius-common/counter";
import LaunchIcon from "@material-ui/icons/Launch";
import AssistantIcon from "@material-ui/icons/Assistant";
import UsersImageArray from "./usersImageArray";
import { getUsers } from "../selectors";
import TagList from "./tagList";

const Group = (props) => {
    const {
        tags,
        data,
        botAssistantEnabled,
        handleOpenEditGroupDialog,
        handleOpenDeleteGroupDialog,
        handleOpenLeaveGroupDialog,
        handleOpenMembersDialog,
        handleOpenMailDialog,
        handleOpenGroupChat,
    } = props;

    const history = useHistory();

    const color = useSelector(getAppColor);
    const employees = useSelector(getUsers);
    const userData = useSelector(getUserData);

    const { img, participants, description, name, ownerName, owner, warehouse, ownerIsGone, hasBotAssistant } = data;

    const isOwner = userData.code === owner;
    const hasImage = Boolean(img);

    const handleOpenDigitalWarehouse = () => {
        history.push({
            pathname: paths.digitalWarehouse,
            search: `?code=${data.id}`,
            state: {
                name: name,
            },
        });
    };

    return (
        <Card style={{ borderRadius: 10 }}>
            {hasImage && (
                <div
                    style={{
                        height: 120,
                        backgroundImage: hasImage ? `url("${IMAGES_ENDPOINT + img}")` : "",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundColor: !hasImage ? color : "",
                    }}
                />
            )}
            <div style={{ padding: "5px 15px" }}>
                <Grid container alignItems="center" item style={{ borderBottom: `1px solid ${color}` }}>
                    <Grid item xs={11}>
                        <Typography
                            className="whiteText"
                            style={{ fontWeight: 700, fontSize: 18, wordBreak: "break-word" }}
                        >
                            {name}
                        </Typography>
                    </Grid>
                    <Grid item xs={1}>
                        <DotsMenu>
                            <MenuItem onClick={() => handleOpenMailDialog(participants, name)}>
                                {getLocalizedString("sendMessage")}
                            </MenuItem>
                            {(isOwner || ownerIsGone) && (
                                <MenuItem onClick={() => handleOpenEditGroupDialog(data)}>
                                    {getLocalizedString("edit")}
                                </MenuItem>
                            )}
                            {(isOwner || ownerIsGone) && (
                                <MenuItem onClick={() => handleOpenDeleteGroupDialog(data)}>
                                    {getLocalizedString("delete")}
                                </MenuItem>
                            )}
                            {(!isOwner || ownerIsGone) && (
                                <MenuItem onClick={() => handleOpenLeaveGroupDialog(data)}>
                                    {getLocalizedString("groupLeave")}
                                </MenuItem>
                            )}
                        </DotsMenu>
                    </Grid>
                </Grid>
                <div
                    style={{
                        padding: "15px 0px",
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 15,
                        }}
                    >
                        <ProfileImg
                            image={employees.find((employee) => employee.key === owner)?.FOTOGRAFIA}
                            size={32}
                        />
                        <div>
                            <Typography className="whiteText" style={{ fontWeight: 600, wordBreak: "break-word" }}>
                                {ownerName}
                            </Typography>
                            <Typography className="whiteText" variant="caption">
                                {getLocalizedString("groupOwner")}
                            </Typography>
                        </div>
                    </div>
                    {description && (
                        <Typography className="whiteText" style={{ padding: "5px 0px" }}>
                            {description}
                        </Typography>
                    )}
                    <div
                        onClick={() => handleOpenMembersDialog(data)}
                        style={{
                            cursor: "pointer",
                            background: "var(--tertiaryBackgroundColor)",
                            border: "1px solid var(--borderColor)",
                            borderRadius: 10,
                            padding: "10px 15px",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <Typography
                                className="whiteText"
                                style={{ cursor: "pointer", textDecoration: "underline" }}
                            >
                                {getLocalizedString("groupMembers")}
                            </Typography>
                            <Counter value={participants.length} />
                        </div>
                        <UsersImageArray users={participants} employees={employees} />
                    </div>
                    {Boolean(data.tags?.length) && <TagList tags={tags} values={data.tags} />}
                    {warehouse && (
                        <div
                            style={{
                                paddingTop: 15,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexWrap: "wrap",
                                gap: "10px 15px",
                            }}
                        >
                            <div
                                onClick={handleOpenDigitalWarehouse}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 5,
                                }}
                            >
                                <LaunchIcon style={{ fill: "var(--mainText)" }} />
                                <Typography
                                    className="whiteText"
                                    variant="caption"
                                    style={{ textDecoration: "underline" }}
                                >
                                    {getLocalizedString("digitalWarehouse")}
                                </Typography>
                            </div>
                            {botAssistantEnabled && hasBotAssistant && (
                                <div
                                    onClick={handleOpenGroupChat}
                                    style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 5,
                                    }}
                                >
                                    <AssistantIcon style={{ fill: "var(--mainText)" }} />
                                    <Typography
                                        className="whiteText"
                                        variant="caption"
                                        style={{ textDecoration: "underline" }}
                                    >
                                        {getLocalizedString("icariusAssistant")}
                                    </Typography>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default Group;
